import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = ({ setCurrentPage }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: '/images/hero_installation.png',
      title: 'Professional CCTV Installation Services'
    },
    {
      image: '/images/hero_cctv_product.png',
      title: 'Advanced Video Surveillance Equipment'
    },
    {
      image: '/images/hero_voip_install.png',
      title: 'Integrated Communication & Networking'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content">
        <div className="container">
          <div className="hero-text">
            <h1 className="hero-title slide-in-left">
              Advanced CCTV & Surveillance Solutions
            </h1>
            <p className="hero-subtitle slide-in-left">
              We sell high-quality security cameras, NVRs, and VoIP hardware, backed by professional installation services.
              Protect your business and home with cutting-edge equipment and expert setups.
            </p>

            <div className="hero-buttons slide-in-left">
              <button
                className="btn btn-primary hero-btn"
                onClick={() => setCurrentPage('services')}
              >
                View Services
              </button>
              <button
                className="btn btn-secondary hero-btn"
                onClick={() => setCurrentPage('products')}
              >
                Browse Products
              </button>
            </div>

            <div className="hero-features">
              <div className="hero-feature">
                <span className="feature-icon">
                  <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="3" width="16" height="10" rx="2" ry="2" />
                    <path d="M18 8l4-3v8l-4-3" />
                    <path d="M2 17h16" />
                  </svg>
                </span>
                <span className="feature-text">500+ Systems Installed</span>
              </div>
              <div className="hero-feature">
                <span className="feature-icon">
                  <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                </span>
                <span className="feature-text">24/7 Technical Support</span>
              </div>
              <div className="hero-feature">
                <span className="feature-icon">
                  <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M2 12h20" />
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                  </svg>
                </span>
                <span className="feature-text">Remote Monitoring Setup</span>
              </div>
            </div>

            {/* 🎓 Certificate Trust Badge */}
            <div className="certificate-badge-wrapper">
              <button
                className="certificate-badge"
                onClick={() => setCurrentPage('certificates')}
                aria-label="View Professional Certifications"
              >
                <span className="badge-icon">
                  <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="8" r="6" />
                    <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
                  </svg>
                </span>
                <div className="badge-content">
                  <span className="badge-text">Certified IT Professionals</span>
                  <span className="badge-subtext">View Credentials →</span>
                </div>
              </button>
            </div>
          </div>

          <div className="hero-image-carousel slide-in-right">
            <div className="carousel-wrapper">
              {slides.map((slide, index) => (
                <div
                  key={index}
                  className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                  style={{ backgroundImage: `url(${slide.image})` }}
                  role="img"
                  aria-label={slide.title}
                />
              ))}
            </div>
            
            {/* Slide Title Banner */}
            <div className="carousel-caption">
              <h4>{slides[currentSlide].title}</h4>
            </div>

            {/* Dot Navigation Indicators */}
            <div className="carousel-dots">
              {slides.map((_, index) => (
                <button
                  key={index}
                  className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;